import React, { useState } from 'react';
import { ImageLoader } from '../_atoms';
import '../styles/books_item.scss';

export const BooksItem = ({ item, onItemClick }) => {
  const [counter, setCounter] = useState(0);
  const onPrevClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setCounter(v => (v - 1 < 0 ? item.additional_photo.length - 1 : v - 1));
  };
  const onNextClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setCounter(v => (v + 1 === item.additional_photo.length ? 0 : v + 1));
  };
  const image = item.additional_photo[counter] || item.logo;
  const showArrows = item.additional_photo.length > 1;
  return (
    <div role="none" className="books-item-wrapper" onClick={onItemClick}>
      <div role="none" className="books-item" onClick={onItemClick}>
        <p className="books-item-title">{item.name}</p>
        <div className="books-item-image">
          <ImageLoader src={image} className="books-item-image__image" />
          {showArrows && <div role="none" className="chevron left" onClick={onPrevClick} />}
          {showArrows && <div role="none" className="chevron right" onClick={onNextClick} />}
        </div>
      </div>
    </div>
  );
};
